/**
 * Domain enums and unions.
 *
 * These mirror the `check (... in (...))` constraints in
 * docs/03-technical-architecture.md §4.2 EXACTLY. If a constraint changes in a
 * migration, it changes here in the same commit — the client and the edge
 * functions both read these, so drift is a production bug, not a lint warning.
 */

/** content_items.type */
export const CONTENT_TYPES = ['lesson', 'short_lesson', 'exercise'] as const
export type ContentType = (typeof CONTENT_TYPES)[number]

/** content_items.video_status */
export const VIDEO_STATUSES = ['none', 'uploading', 'processing', 'ready', 'failed'] as const
export type VideoStatus = (typeof VIDEO_STATUSES)[number]

/** subscriptions.status */
export const SUBSCRIPTION_STATUSES = ['active', 'expired', 'revoked'] as const
export type SubscriptionStatus = (typeof SUBSCRIPTION_STATUSES)[number]

/** subscriptions.source */
export const SUBSCRIPTION_SOURCES = ['mock', 'admin', 'bankily', 'masrvi', 'sedad'] as const
export type SubscriptionSource = (typeof SUBSCRIPTION_SOURCES)[number]

/** transactions.status */
export const TRANSACTION_STATUSES = ['pending', 'paid', 'failed', 'refunded'] as const
export type TransactionStatus = (typeof TRANSACTION_STATUSES)[number]

/** plans.scope */
export const PLAN_SCOPES = ['all', 'subjects', 'program', 'stream'] as const
export type PlanScope = (typeof PLAN_SCOPES)[number]

/** admin_users.role */
export const ADMIN_ROLES = ['super_admin', 'content_manager', 'moderator', 'support'] as const
export type AdminRole = (typeof ADMIN_ROLES)[number]

/** notifications.type */
export const NOTIFICATION_TYPES = ['announcement', 'reply', 'subscription', 'system'] as const
export type NotificationType = (typeof NOTIFICATION_TYPES)[number]

/** profiles.locale */
export const LOCALES = ['ar', 'fr'] as const
export type Locale = (typeof LOCALES)[number]

/** profiles.theme */
export const THEMES = ['light', 'dark', 'system'] as const
export type Theme = (typeof THEMES)[number]

/** profiles.gender */
export const GENDERS = ['male', 'female'] as const
export type Gender = (typeof GENDERS)[number]

/** reports.target_type */
export const REPORT_TARGET_TYPES = ['post', 'reply'] as const
export type ReportTargetType = (typeof REPORT_TARGET_TYPES)[number]

/** reports.status */
export const REPORT_STATUSES = ['open', 'dismissed', 'actioned'] as const
export type ReportStatus = (typeof REPORT_STATUSES)[number]

/** device_tokens.platform */
export const PLATFORMS = ['ios', 'android'] as const
export type Platform = (typeof PLATFORMS)[number]

/** support_messages.kind */
export const SUPPORT_KINDS = ['contact', 'suggestion'] as const
export type SupportKind = (typeof SUPPORT_KINDS)[number]

/** cms_pages.key */
export const CMS_PAGE_KEYS = ['about', 'privacy', 'terms'] as const
export type CmsPageKey = (typeof CMS_PAGE_KEYS)[number]
